export const courseOrder=['play-workshop','player-interface','level-design-lab','decision-lab','encounter-lab','production-course','asset-pipeline','online-journey','production-planner'];
